module.exports = __webpack_public_path__ + "img/red_dragon_small.6126d10f.png";